var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationSalesForCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 24.375H20.625V18.125H23.125M20.625 21.875H23.125M15.625 18.125V24.375H18.125M8.125 18.125H5.625V20.625L8.125 21.875V24.375H5.625",
    stroke: "#186419",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.625 16.875V28.125H3.125V16.875M0.625 28.125H28.125",
    stroke: "#186419",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 24.375V20L11.875 18.125L13.125 20V24.375M10.625 21.875H13.125M28.125 9.375H0.625M28.125 9.375L24.375 3.125H4.375L0.625 9.375M28.125 9.375V12.5L26.25 14.375L24.375 12.5M0.625 9.375V12.5L2.5 14.375L4.375 12.5M8.125 3.125L4.375 9.375V12.5M11.875 3.125L9.375 9.375V12.5M14.375 3.125V9.375V12.5M14.375 12.5L11.875 14.375L9.375 12.5M14.375 12.5L16.875 14.375L19.375 12.5L21.875 14.375L24.375 12.5M9.375 12.5L6.875 14.375L4.375 12.5M20.625 3.125L24.375 9.375V12.5M16.875 3.125L19.375 9.375V12.4825",
    stroke: "#186419",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationSalesForCom);
export default __webpack_public_path__ + "static/media/OperationSalesForCom.174288364deb9a9ff185d25e943774d2.svg";
export { ForwardRef as ReactComponent };